var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-tag"},[_c('div',{class:['tag-color', `${_vm.colorClass}`]}),_c('div',{staticClass:"tag-content"},[_vm._t("tagContent")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }